module.exports = __webpack_public_path__ + "static/media/falsch.498997fd.jpg";